var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-12"},[_c('Chart',{attrs:{"tipo":"Bar","opcoes":_vm.opcoes,"url":"/contratos/bi/valor-dos-empenhos-por-contrato"}})],1)])}
var staticRenderFns = []

export { render, staticRenderFns }